/* Siora SkinInsights data (auto-generated). */
window.SI_PRODUCTS={
  "_about": "Real Siora catalog (handles, prices, images, ingredient %s from siora.pk/products.json). Ratings: Anti-Acne Serum (4.6/5) is live from Judge.me; others are representative placeholders — wire the Judge.me API for live values. 'actives' reference data/knowledge.json ingredient ids.",
  "currency": "PKR",
  "currencySymbol": "Rs.",
  "products": [
    { "id":"niacinamide-serum", "title":"Niacinamide Serum", "subtitle":"10% Niacinamide · Balance Oil & Refine Pores",
      "url":"https://siora.pk/products/niacinamide-serum-balance-oil-refine-pores",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/Niacinamidesiorawhiteproductrefineshootcopy_fa16c8ee-aa85-4e89-8ccf-45beb62bf91f.png?v=1766605453",
      "price":1290, "compareAt":1890, "type":"serum", "step":"treatment",
      "actives":["niacinamide","zincPCA","hyaluronicAcid"], "concerns":["oiliness","pores","redness","uniformity","pigmentation"],
      "rating":4.7, "reviews":41, "reviewSnippet":"My pores look smaller and my skin is way less oily by afternoon." },

    { "id":"anti-acne-serum", "title":"Anti-Acne Serum", "subtitle":"2% Salicylic + 5% Niacinamide · Clear, Calm, Control",
      "url":"https://siora.pk/products/anti-acne-serum-clear-calm-control",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/siorawhiteproductrefineshootcopy.png?v=1766603334",
      "price":1290, "compareAt":1890, "type":"serum", "step":"treatment",
      "actives":["salicylicAcid","niacinamide","teaTree"], "concerns":["acne","oiliness","pores"],
      "rating":4.6, "reviews":5, "reviewSnippet":"I have oily, acne-prone skin and this serum has been a lifesaver — so lightweight!" },

    { "id":"hyaluronic-serum", "title":"Hyaluronic Acid Serum", "subtitle":"2% Multi-weight HA + 5% Niacinamide · Deep Hydration",
      "url":"https://siora.pk/products/hyaluronic-acid-serum-deep-hydration-plumping-care",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/Hyaluronicsiorawhiteproductrefineshootcopy.png?v=1767025478",
      "price":1290, "compareAt":1890, "type":"serum", "step":"hydrate",
      "actives":["hyaluronicAcid","niacinamide","panthenol"], "concerns":["hydration","lines","redness"],
      "rating":4.8, "reviews":63, "reviewSnippet":"Skin feels plump and dewy — the dry patches are gone." },

    { "id":"vitc-serum", "title":"Vitamin C Serum", "subtitle":"15% Ethyl Ascorbic Acid · Brighten & Protect",
      "url":"https://siora.pk/products/vitamin-c-serum-brighten-protect",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/vitamCsiorawhiteproductrefineshootcopy.png?v=1766757269",
      "price":990, "compareAt":1690, "type":"serum", "step":"treatment",
      "actives":["vitaminC","niacinamide","hyaluronicAcid"], "concerns":["pigmentation","skinTone","uniformity","lines","darkCircles"],
      "rating":4.6, "reviews":19, "reviewSnippet":"My dark spots are fading and my face looks brighter overall." },

    { "id":"whitening-serum", "title":"Whitening Serum", "subtitle":"2% Alpha Arbutin + 10% Niacinamide · Tone Correction",
      "url":"https://siora.pk/products/whitening-serum-advanced-tone-correction-brightening",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/whiteningsiorawhiteproductrefineshootcopy.png?v=1766758198",
      "price":990, "compareAt":1690, "type":"serum", "step":"treatment",
      "actives":["alphaArbutin","niacinamide","licorice"], "concerns":["pigmentation","skinTone","uniformity","darkCircles"],
      "rating":4.5, "reviews":22, "reviewSnippet":"Pigmentation from old acne marks is genuinely lighter after a month." },

    { "id":"rice-serum", "title":"Rice Serum", "subtitle":"Fermented Rice + 5% Niacinamide · Glass-Skin Glow",
      "url":"https://siora.pk/products/rice-serum-hydrate-brighten-strengthen",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/ricesiorawhiteproductrefineshootcopy.png?v=1766755608",
      "price":990, "compareAt":1690, "type":"serum", "step":"treatment",
      "actives":["riceFerment","niacinamide","hyaluronicAcid"], "concerns":["skinTone","uniformity","hydration"],
      "rating":4.6, "reviews":28, "reviewSnippet":"That K-beauty glow is real — even tone and so much glow." },

    { "id":"retinol-serum", "title":"Retinol Serum", "subtitle":"0.3% Encapsulated Retinol · Renew & Smooth",
      "url":"https://siora.pk/products/retinol-serum-renew-smooth",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/retinolsiorawhiteproductrefineshootcopy.png?v=1766606499",
      "price":1290, "compareAt":1890, "type":"serum", "step":"treatment",
      "actives":["retinol","vitaminE","hyaluronicAcid"], "concerns":["lines","pores","uniformity"],
      "rating":4.4, "reviews":12, "reviewSnippet":"Gentle enough for a beginner and my texture is smoother." },

    { "id":"anti-acne-wash", "title":"Anti-Acne Face Wash", "subtitle":"Salicylic + Tea Tree · Clear, Calm, Balanced",
      "url":"https://siora.pk/products/anti-acne-face-wash-clear-calm-balanced",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/anti_acne_facewash_ai.jpg?v=1768585651",
      "price":890, "compareAt":1290, "type":"wash", "step":"cleanse",
      "actives":["salicylicAcid","teaTree"], "concerns":["acne","oiliness"],
      "rating":4.5, "reviews":31, "reviewSnippet":"Breakouts calmed down within two weeks of using this daily." },

    { "id":"charcoal-wash", "title":"Charcoal Face Wash", "subtitle":"Activated Charcoal · Deep Detox",
      "url":"https://siora.pk/products/charcoal-face-wash-deep-detox-pore-cleansing",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/charcol_facewash.jpg?v=1768584495",
      "price":890, "compareAt":1290, "type":"wash", "step":"cleanse",
      "actives":["charcoal"], "concerns":["oiliness","pores"],
      "rating":4.4, "reviews":18, "reviewSnippet":"Skin feels squeaky-clean and matte without feeling tight." },

    { "id":"vitc-wash", "title":"Vitamin C Face Wash", "subtitle":"Vitamin C · Brighten, Refresh, Glow",
      "url":"https://siora.pk/products/vitamin-c-facewash-brighten-refresh-glow",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/vitamin_c_facewash_copy.jpg?v=1768575220",
      "price":890, "compareAt":1290, "type":"wash", "step":"cleanse",
      "actives":["vitaminC"], "concerns":["skinTone","uniformity","pigmentation"],
      "rating":4.5, "reviews":14, "reviewSnippet":"Wakes my dull skin up in the morning — brighter instantly." },

    { "id":"whitening-wash", "title":"Whitening Face Wash", "subtitle":"Brighten, Tone, Glow",
      "url":"https://siora.pk/products/whitening-face-wash-brighten-tone-glow",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/whiteningfacewashcopy2.jpg?v=1768585169",
      "price":890, "compareAt":1290, "type":"wash", "step":"cleanse",
      "actives":["niacinamide","licorice"], "concerns":["pigmentation","skinTone"],
      "rating":4.4, "reviews":11, "reviewSnippet":"Tone looks more even and clean after a few weeks." },

    { "id":"all-in-one-wash", "title":"All-In-One Face Wash", "subtitle":"Cleanse, Balance, Hydrate",
      "url":"https://siora.pk/products/siora-all-in-one-facewash-cleanse-balance-hydrate",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/all_in_one_facewash_2.jpg?v=1773339063",
      "price":890, "compareAt":1290, "type":"wash", "step":"cleanse",
      "actives":["panthenol","niacinamide"], "concerns":["hydration","redness"],
      "rating":4.6, "reviews":20, "reviewSnippet":"Gentle, non-stripping — perfect for my sensitive skin." },

    { "id":"sunblock", "title":"Sun Block SPF 50+", "subtitle":"SPF 50+ · PA++++ · Protect, Matte, Prevent",
      "url":"https://siora.pk/products/sun-block-protect-matte-prevent",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/sunblock_f573a73f-ee34-435e-ad16-f7d5c2c24908.jpg?v=1768606635",
      "price":890, "compareAt":1290, "type":"spf", "step":"protect",
      "actives":["spf"], "concerns":["pigmentation","skinTone","lines","darkCircles","uniformity"],
      "rating":4.7, "reviews":24, "reviewSnippet":"No white cast, matte finish — finally an SPF I'll actually wear daily." },

    { "id":"all-in-one-serum", "title":"All-in-One Face Serum", "subtitle":"10% Niacinamide + Vitamin C + HA · Balance, Repair, Glow",
      "url":"https://siora.pk/products/all-in-one-serum-balance-repair-glow",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/allinonewhitetheecopy.png?v=1766596022",
      "price":990, "compareAt":1435, "type":"serum", "step":"treatment",
      "actives":["niacinamide","vitaminC","hyaluronicAcid"], "concerns":["oiliness","skinTone","pigmentation","hydration","uniformity","redness"],
      "rating":4.6, "reviews":17, "reviewSnippet":"One serum that does it all — brighter, balanced and hydrated." }
  ],

  "_kits_about": "The 11 real concern-targeted combos live on siora.pk (Rs 1590 each). Each 'products' array lists the constituent single-product ids — the recommender derives concern coverage + active efficacy from those, so a combo is scored by what is actually inside it, not a hand-typed tag. Ratings/review counts for the combos are representative (new bundles); the individual products carry the live values.",
  "kits": [
    { "id":"combo-acne-control", "title":"Acne Control Serum & Face Wash Combo", "subtitle":"2-step · clear breakouts, control oil, fade marks",
      "handle":"anti-acne-clear-skin-set", "url":"https://siora.pk/products/anti-acne-clear-skin-set",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/Anti_Acne_Combo_001.jpg?v=1785163935",
      "price":1590, "compareAt":3180, "rating":4.6, "reviews":8, "products":["anti-acne-wash","anti-acne-serum"],
      "blurb":"Anti-Acne Face Wash clears sebum, then 2% Salicylic + 5% Niacinamide stops new breakouts and fades marks." },

    { "id":"combo-acne-marks", "title":"Acne Marks & Spots Repair Combo", "subtitle":"2-step · stop breakouts, fade the marks behind",
      "handle":"acne-mark-fading-set", "url":"https://siora.pk/products/acne-mark-fading-set",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/Acne_Marks_Spots_Repair_Combo_001.jpg?v=1785165354",
      "price":1590, "compareAt":3180, "rating":4.6, "reviews":11, "products":["anti-acne-wash","niacinamide-serum"],
      "blurb":"Salicylic wash keeps pores clear while 10% Niacinamide fades the red and brown marks past breakouts left." },

    { "id":"combo-pores-oil", "title":"Pores & Oily Skin Combo", "subtitle":"2-step · unclog pores, kill midday shine",
      "handle":"pore-minimizing-oil-control-set", "url":"https://siora.pk/products/pore-minimizing-oil-control-set",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/Pores_Oily_Skin_Combo_001.jpg?v=1784911296",
      "price":1590, "compareAt":3180, "rating":4.6, "reviews":9, "products":["charcoal-wash","niacinamide-serum"],
      "blurb":"Activated Charcoal pulls oil from pores, then 10% Niacinamide + Zinc PCA regulate sebum so pores stay refined." },

    { "id":"combo-pigmentation", "title":"Dark Spots & Pigmentation Combo", "subtitle":"2-step · fade dark spots, even the tone",
      "handle":"dark-spot-brightening-set", "url":"https://siora.pk/products/dark-spot-brightening-set",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/Dark_Spots_Pigmentation_Combo_001.jpg?v=1785164641",
      "price":1590, "compareAt":3180, "rating":4.5, "reviews":7, "products":["whitening-wash","whitening-serum"],
      "blurb":"2% Alpha Arbutin inhibits excess melanin at the source, with 10% Niacinamide + Licorice to brighten and calm." },

    { "id":"combo-brightening", "title":"Dull Skin Brightening Combo", "subtitle":"2-step · wake up dull skin, build glow",
      "handle":"vitamin-c-glow-set", "url":"https://siora.pk/products/vitamin-c-glow-set",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/Dull_Skin_Brightening_Combo_001.jpg?v=1785164914",
      "price":1590, "compareAt":3180, "rating":4.6, "reviews":6, "products":["vitc-wash","vitc-serum"],
      "blurb":"Vitamin C at both steps — the wash lifts dead surface buildup, the 15% serum fades spots and defends against damage." },

    { "id":"combo-glass-skin", "title":"Glass Skin Glow Combo", "subtitle":"2-step · hydrate, brighten, refine texture",
      "handle":"glass-skin-glow-set", "url":"https://siora.pk/products/glass-skin-glow-set",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/Glass_Skin_Glow_Combo_001.jpg?v=1785165192",
      "price":1590, "compareAt":3180, "rating":4.6, "reviews":9, "products":["all-in-one-wash","rice-serum"],
      "blurb":"A balanced cleansing base, then fermented Rice + Niacinamide + HA for lit-from-within, even-toned glow." },

    { "id":"combo-hydration", "title":"Dry Skin Hydration Combo", "subtitle":"2-step · non-stripping wash + all-day moisture",
      "handle":"hydrating-plumping-set", "url":"https://siora.pk/products/hydrating-plumping-set",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/Dry_Skin_Hydration_Combo_001.jpg?v=1785165061",
      "price":1590, "compareAt":3180, "rating":4.7, "reviews":12, "products":["all-in-one-wash","hyaluronic-serum"],
      "blurb":"A hydrating wash that cleans without tightness, plus 2% multi-weight Hyaluronic Acid that holds moisture all day." },

    { "id":"combo-hydrate-protect", "title":"Hydrate & Protect Combo", "subtitle":"2-step · plump with HA, defend with SPF 50",
      "handle":"hydrating-sun-protection-set", "url":"https://siora.pk/products/hydrating-sun-protection-set",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/hyaluronic_acid_serum_and_sunscreen.png?v=1785163846",
      "price":1590, "compareAt":3180, "rating":4.8, "reviews":10, "products":["hyaluronic-serum","sunblock"],
      "blurb":"Hyaluronic Acid locks in moisture and SPF 50+ prevents the sun damage that undoes every other step." },

    { "id":"combo-fine-lines", "title":"Fine Lines & Skin Texture Combo", "subtitle":"2-step · beginner retinol, smoother overnight",
      "handle":"retinol-anti-aging-set", "url":"https://siora.pk/products/retinol-anti-aging-set",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/Fine_Lines_Skin_Texture_Combo_001.jpg?v=1785165534",
      "price":1590, "compareAt":3180, "rating":4.5, "reviews":7, "products":["all-in-one-wash","retinol-serum"],
      "blurb":"A gentle hydrating wash paired with 0.3% encapsulated Retinol that smooths lines and texture without the peel cycle." },

    { "id":"combo-all-in-one", "title":"All-in-One Daily Skincare Combo", "subtitle":"2-step · cleanse, hydrate, brighten, protect",
      "handle":"all-in-one-daily-set", "url":"https://siora.pk/products/all-in-one-daily-set",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/All-in-One_Daily_Skincare_Combo_001.jpg?v=1785165681",
      "price":1590, "compareAt":3180, "rating":4.6, "reviews":14, "products":["all-in-one-wash","all-in-one-serum"],
      "blurb":"Two bottles that do everything — an all-in-one wash, then 10% Niacinamide + Vitamin C + HA in a single serum." },

    { "id":"combo-clear-trio", "title":"Clear Skin Face Wash Trio", "subtitle":"3 washes · brighten, clear, detox for oily skin",
      "handle":"clear-skin-face-wash-trio", "url":"https://siora.pk/products/clear-skin-face-wash-trio",
      "image":"https://cdn.shopify.com/s/files/1/0967/6954/0401/files/Clear_Skin_Face_Wash_Trio_001.jpg?v=1785165807",
      "price":1590, "compareAt":3870, "rating":4.5, "reviews":7, "products":["vitc-wash","anti-acne-wash","charcoal-wash"],
      "blurb":"The right cleanser for each need: Vitamin C to brighten AM, Salicylic to clear PM, Charcoal to detox twice weekly." }
  ]
}
;
window.SI_CONCERNS={
  "_note": "score 0-100 where 100 = best/healthiest. grade bands map score -> A..E. 'metric' is the CV signal that primarily drives this concern.",
  "gradeBands": [
    { "grade": "A", "min": 85, "label": "Excellent" },
    { "grade": "B", "min": 70, "label": "Good" },
    { "grade": "C", "min": 50, "label": "Fair" },
    { "grade": "D", "min": 30, "label": "Needs care" },
    { "grade": "E", "min": 0,  "label": "Priority" }
  ],
  "concerns": [
    {
      "id": "acne",
      "label": "Acne",
      "metric": "blemishes",
      "regions": ["forehead", "cheekLeft", "cheekRight", "chin"],
      "saw": "We scanned for blemishes and breakout texture across your T-zone and cheeks.",
      "helps": "A Salicylic Acid routine to clear and prevent breakouts."
    },
    {
      "id": "oiliness",
      "label": "Oiliness",
      "metric": "specular",
      "regions": ["forehead", "noseBridge", "chin"],
      "saw": "We measured shine (specular highlights) in your T-zone.",
      "helps": "Oil-balancing Niacinamide and a deep-cleansing wash."
    },
    {
      "id": "pores",
      "label": "Pores",
      "metric": "texture",
      "regions": ["noseBridge", "cheekLeft", "cheekRight"],
      "saw": "We analysed micro-texture and visible pore density around the nose and cheeks.",
      "helps": "Pore-refining Niacinamide and gentle exfoliation."
    },
    {
      "id": "darkCircles",
      "label": "Dark Circles",
      "metric": "underEye",
      "regions": ["underEyeLeft", "underEyeRight"],
      "saw": "We compared under-eye brightness against your cheek tone.",
      "helps": "Brightening actives plus daily SPF to prevent darkening."
    },
    {
      "id": "pigmentation",
      "label": "Pigmentation",
      "metric": "spots",
      "regions": ["cheekLeft", "cheekRight", "forehead"],
      "saw": "We looked for dark spots and patches of concentrated melanin.",
      "helps": "Alpha Arbutin / Vitamin C to fade spots, SPF to prevent more."
    },
    {
      "id": "skinTone",
      "label": "Skin Tone",
      "metric": "ita",
      "regions": ["cheekLeft", "cheekRight", "forehead"],
      "saw": "We estimated your overall tone and brightness (ITA°).",
      "helps": "Brightening Vitamin C / Rice actives for a healthy glow."
    },
    {
      "id": "uniformity",
      "label": "Uniformness",
      "metric": "evenness",
      "regions": ["forehead", "cheekLeft", "cheekRight", "chin"],
      "saw": "We measured how even your colour is across different zones.",
      "helps": "Tone-evening actives and consistent SPF."
    },
    {
      "id": "redness",
      "label": "Redness",
      "metric": "redness",
      "regions": ["cheekLeft", "cheekRight", "noseBridge"],
      "saw": "We measured redness (LAB a*) on your cheeks and nose.",
      "helps": "Soothing Niacinamide and a non-stripping cleanser."
    },
    {
      "id": "hydration",
      "label": "Hydration",
      "metric": "hydration",
      "regions": ["cheekLeft", "cheekRight"],
      "saw": "We estimated surface dryness and dullness.",
      "helps": "Hyaluronic Acid to restore and lock in moisture."
    },
    {
      "id": "lines",
      "label": "Fine Lines",
      "metric": "wrinkles",
      "regions": ["forehead", "underEyeLeft", "underEyeRight"],
      "saw": "We scanned for fine lines on the forehead and under-eye area.",
      "helps": "Retinol to smooth texture and HA to plump lines."
    }
  ]
}
;
window.SI_KNOWLEDGE={
  "_about": "Evidence-based dermatology knowledge base that grounds grading, advice and product ranking. Compiled from open dermatology literature (concern mechanisms, ITA tone, Glogau photoaging, IGA acne, active-ingredient efficacy). Efficacy = 0..1 strength of evidence for an active against a concern.",
  "concerns": {
    "acne": {
      "definition": "Inflammatory lesions and comedones from clogged, bacteria-colonised pores.",
      "cause": "Excess sebum + dead-skin buildup + C. acnes bacteria + inflammation. Worsened by heat/humidity and friction.",
      "measure": "Redness clusters + textural irregularity in T-zone, cheeks and chin.",
      "scale": [
        [
          "A",
          "Clear"
        ],
        [
          "B",
          "Occasional"
        ],
        [
          "C",
          "Mild–moderate"
        ],
        [
          "D",
          "Moderate"
        ],
        [
          "E",
          "Persistent"
        ]
      ],
      "actives": [
        "salicylicAcid",
        "niacinamide",
        "teaTree",
        "zincPCA",
        "azelaicAcid",
        "greenTea"
      ],
      "tip": "Avoid over-washing (max 2×/day); never pick — it drives marks and scarring."
    },
    "oiliness": {
      "definition": "Over-active sebaceous glands giving shine and a greasy feel.",
      "cause": "Genetics, heat/humidity and barrier disruption push sebum output up.",
      "measure": "Specular-highlight ratio across forehead, nose and chin (T-zone).",
      "scale": [
        [
          "A",
          "Balanced"
        ],
        [
          "B",
          "Slight shine"
        ],
        [
          "C",
          "Combination"
        ],
        [
          "D",
          "Oily"
        ],
        [
          "E",
          "Very oily"
        ]
      ],
      "actives": [
        "niacinamide",
        "zincPCA",
        "salicylicAcid",
        "charcoal",
        "greenTea"
      ],
      "tip": "Stripping cleansers backfire — they trigger more oil. Use gentle, balancing care."
    },
    "pores": {
      "definition": "Visibly enlarged pore openings, mostly nose and cheeks.",
      "cause": "Oil, loss of elasticity and sun damage stretch pore walls.",
      "measure": "High-frequency micro-texture / local variance on nose and cheeks.",
      "scale": [
        [
          "A",
          "Refined"
        ],
        [
          "B",
          "Fine"
        ],
        [
          "C",
          "Visible"
        ],
        [
          "D",
          "Enlarged"
        ],
        [
          "E",
          "Prominent"
        ]
      ],
      "actives": [
        "niacinamide",
        "salicylicAcid",
        "retinol"
      ],
      "tip": "Daily SPF protects collagen that keeps pores tight."
    },
    "darkCircles": {
      "definition": "Darkening or shadowing of the under-eye area.",
      "cause": "Thin skin, pigment, poor sleep, dehydration and sun.",
      "measure": "Under-eye luminance compared with cheek luminance.",
      "scale": [
        [
          "A",
          "Bright"
        ],
        [
          "B",
          "Faint"
        ],
        [
          "C",
          "Visible"
        ],
        [
          "D",
          "Pronounced"
        ],
        [
          "E",
          "Deep"
        ]
      ],
      "actives": [
        "niacinamide",
        "vitaminC",
        "spf"
      ],
      "tip": "Sleep, hydration and daily SPF make the biggest visible difference."
    },
    "pigmentation": {
      "definition": "Localised dark spots / patches of excess melanin (PIH, melasma, sun spots).",
      "cause": "UV exposure and post-inflammatory response over-produce melanin.",
      "measure": "Dark-blob detection + tone variance across cheeks and forehead.",
      "scale": [
        [
          "A",
          "Even"
        ],
        [
          "B",
          "Minor spots"
        ],
        [
          "C",
          "Noticeable"
        ],
        [
          "D",
          "Patchy"
        ],
        [
          "E",
          "Significant"
        ]
      ],
      "actives": [
        "alphaArbutin",
        "vitaminC",
        "niacinamide",
        "licorice",
        "spf",
        "tranexamicAcid",
        "kojicAcid",
        "azelaicAcid",
        "glycolicAcid"
      ],
      "tip": "Pigment treatment fails without daily SPF — UV re-darkens spots fastest."
    },
    "skinTone": {
      "definition": "Overall brightness/evenness of complexion (ITA° individual typology angle).",
      "cause": "Dullness from dead-cell buildup, dehydration, sun and pollution.",
      "measure": "ITA° from L* and b*; lower brightness = duller.",
      "scale": [
        [
          "A",
          "Radiant"
        ],
        [
          "B",
          "Healthy"
        ],
        [
          "C",
          "Slightly dull"
        ],
        [
          "D",
          "Dull"
        ],
        [
          "E",
          "Very dull"
        ]
      ],
      "actives": [
        "vitaminC",
        "riceFerment",
        "niacinamide",
        "alphaArbutin",
        "glycolicAcid",
        "ferulicAcid"
      ],
      "tip": "Antioxidants + exfoliation reveal fresher, brighter skin."
    },
    "uniformity": {
      "definition": "How even your colour is across different facial zones.",
      "cause": "Mixed pigmentation, redness and texture create an uneven look.",
      "measure": "Std-deviation of luminance/tone across forehead, cheeks and chin.",
      "scale": [
        [
          "A",
          "Very even"
        ],
        [
          "B",
          "Even"
        ],
        [
          "C",
          "Slightly uneven"
        ],
        [
          "D",
          "Uneven"
        ],
        [
          "E",
          "Blotchy"
        ]
      ],
      "actives": [
        "niacinamide",
        "vitaminC",
        "riceFerment",
        "retinol",
        "glycolicAcid",
        "lacticAcid"
      ],
      "tip": "Consistency beats intensity — steady daily actives even tone over weeks."
    },
    "redness": {
      "definition": "Diffuse facial redness / reactive, irritated skin.",
      "cause": "Barrier weakness, sensitivity, heat and harsh products dilate vessels.",
      "measure": "CIE-LAB a* channel on cheeks and nose.",
      "scale": [
        [
          "A",
          "Calm"
        ],
        [
          "B",
          "Slight"
        ],
        [
          "C",
          "Noticeable"
        ],
        [
          "D",
          "Reactive"
        ],
        [
          "E",
          "Persistent"
        ]
      ],
      "actives": [
        "niacinamide",
        "panthenol",
        "licorice",
        "teaTree",
        "centella",
        "azelaicAcid"
      ],
      "tip": "Simplify — fewer, gentler products and a strong barrier calm redness."
    },
    "hydration": {
      "definition": "Surface moisture and barrier health (dryness/dullness).",
      "cause": "Low humectant levels and a weakened barrier lose water (TEWL).",
      "measure": "Brightness/dullness proxy + texture roughness.",
      "scale": [
        [
          "A",
          "Plump"
        ],
        [
          "B",
          "Hydrated"
        ],
        [
          "C",
          "Slightly dry"
        ],
        [
          "D",
          "Dry"
        ],
        [
          "E",
          "Dehydrated"
        ]
      ],
      "actives": [
        "hyaluronicAcid",
        "panthenol",
        "niacinamide",
        "ceramides",
        "lacticAcid"
      ],
      "tip": "Apply humectants to damp skin, then seal — hydration is your fastest visible win."
    },
    "lines": {
      "definition": "Fine lines and early wrinkles (Glogau photoaging).",
      "cause": "Collagen loss from age + UV; dehydration deepens their look.",
      "measure": "Oriented edge density on forehead and under-eye.",
      "scale": [
        [
          "A",
          "Smooth"
        ],
        [
          "B",
          "Very fine"
        ],
        [
          "C",
          "Fine lines"
        ],
        [
          "D",
          "Visible"
        ],
        [
          "E",
          "Established"
        ]
      ],
      "actives": [
        "retinol",
        "hyaluronicAcid",
        "vitaminC",
        "spf",
        "vitaminE",
        "peptides",
        "bakuchiol",
        "glycolicAcid"
      ],
      "tip": "Retinol at night + SPF by day is the most evidence-backed anti-ageing pair."
    }
  },
  "ingredients": {
    "niacinamide": {
      "name": "Niacinamide (Vitamin B3)",
      "evidence": "strong",
      "treats": {
        "oiliness": 0.8,
        "pores": 0.7,
        "redness": 0.8,
        "uniformity": 0.7,
        "pigmentation": 0.5,
        "hydration": 0.4,
        "acne": 0.5
      },
      "how": "Regulates sebum, strengthens the barrier and calms inflammation."
    },
    "salicylicAcid": {
      "name": "Salicylic Acid (BHA)",
      "evidence": "strong",
      "treats": {
        "acne": 0.9,
        "oiliness": 0.7,
        "pores": 0.8
      },
      "how": "Oil-soluble — penetrates and unclogs pores, dissolving dead skin."
    },
    "retinol": {
      "name": "Retinol",
      "evidence": "strong",
      "treats": {
        "lines": 0.9,
        "pores": 0.6,
        "uniformity": 0.6,
        "acne": 0.4
      },
      "how": "Boosts cell turnover and collagen to smooth texture and lines."
    },
    "alphaArbutin": {
      "name": "Alpha Arbutin",
      "evidence": "good",
      "treats": {
        "pigmentation": 0.8,
        "skinTone": 0.7,
        "uniformity": 0.6,
        "darkCircles": 0.4
      },
      "how": "Inhibits tyrosinase to fade dark spots without bleaching."
    },
    "vitaminC": {
      "name": "Vitamin C",
      "evidence": "strong",
      "treats": {
        "pigmentation": 0.7,
        "skinTone": 0.8,
        "uniformity": 0.6,
        "lines": 0.4,
        "darkCircles": 0.4
      },
      "how": "Antioxidant that brightens, evens tone and shields from damage."
    },
    "hyaluronicAcid": {
      "name": "Hyaluronic Acid",
      "evidence": "strong",
      "treats": {
        "hydration": 0.9,
        "lines": 0.5
      },
      "how": "Multi-weight humectant that holds water across skin layers."
    },
    "zincPCA": {
      "name": "Zinc PCA",
      "evidence": "good",
      "treats": {
        "oiliness": 0.7,
        "acne": 0.5
      },
      "how": "Controls shine and supports clearer skin without stripping."
    },
    "teaTree": {
      "name": "Tea Tree",
      "evidence": "moderate",
      "treats": {
        "acne": 0.6,
        "redness": 0.4
      },
      "how": "Naturally antibacterial; calms breakout inflammation."
    },
    "licorice": {
      "name": "Licorice Root",
      "evidence": "moderate",
      "treats": {
        "pigmentation": 0.6,
        "redness": 0.5
      },
      "how": "Soothes and gently brightens uneven tone."
    },
    "panthenol": {
      "name": "Panthenol (B5)",
      "evidence": "good",
      "treats": {
        "hydration": 0.6,
        "redness": 0.5
      },
      "how": "Repairs and soothes a compromised barrier."
    },
    "charcoal": {
      "name": "Activated Charcoal",
      "evidence": "moderate",
      "treats": {
        "oiliness": 0.6,
        "pores": 0.5
      },
      "how": "Adsorbs excess oil and impurities from pores."
    },
    "riceFerment": {
      "name": "Fermented Rice Extract",
      "evidence": "moderate",
      "treats": {
        "skinTone": 0.6,
        "uniformity": 0.6,
        "hydration": 0.5
      },
      "how": "K-beauty brightener for a luminous, even glow."
    },
    "spf": {
      "name": "SPF 50+ / PA++++",
      "evidence": "strong",
      "treats": {
        "pigmentation": 0.7,
        "skinTone": 0.5,
        "lines": 0.6,
        "darkCircles": 0.3,
        "uniformity": 0.4
      },
      "how": "Prevents the UV damage behind spots, dullness and ageing."
    },
    "vitaminE": {
      "name": "Vitamin E",
      "evidence": "moderate",
      "treats": {
        "lines": 0.3,
        "hydration": 0.3
      },
      "how": "Antioxidant that supports the barrier alongside Vitamin C."
    },
    "azelaicAcid": {
      "name": "Azelaic Acid",
      "evidence": "strong",
      "treats": {
        "acne": 0.7,
        "redness": 0.7,
        "pigmentation": 0.6,
        "uniformity": 0.5
      },
      "how": "Unclogs pores, calms redness/rosacea and fades post-acne marks — well tolerated on deeper tones."
    },
    "glycolicAcid": {
      "name": "Glycolic Acid (AHA)",
      "evidence": "strong",
      "treats": {
        "uniformity": 0.7,
        "skinTone": 0.7,
        "pigmentation": 0.6,
        "lines": 0.5,
        "pores": 0.4
      },
      "how": "Surface exfoliant that smooths texture, brightens and evens tone."
    },
    "lacticAcid": {
      "name": "Lactic Acid (AHA)",
      "evidence": "good",
      "treats": {
        "skinTone": 0.6,
        "uniformity": 0.5,
        "hydration": 0.5
      },
      "how": "Milder AHA — exfoliates while helping skin hold moisture."
    },
    "ceramides": {
      "name": "Ceramides",
      "evidence": "strong",
      "treats": {
        "hydration": 0.8,
        "redness": 0.5
      },
      "how": "Rebuild the skin barrier to lock in water and calm sensitivity."
    },
    "peptides": {
      "name": "Peptides",
      "evidence": "good",
      "treats": {
        "lines": 0.6,
        "hydration": 0.4
      },
      "how": "Signal the skin to firm and support collagen."
    },
    "centella": {
      "name": "Centella Asiatica (Cica)",
      "evidence": "good",
      "treats": {
        "redness": 0.7,
        "hydration": 0.5,
        "acne": 0.4
      },
      "how": "Soothes, repairs the barrier and calms reactive skin."
    },
    "tranexamicAcid": {
      "name": "Tranexamic Acid",
      "evidence": "strong",
      "treats": {
        "pigmentation": 0.8,
        "uniformity": 0.6,
        "skinTone": 0.5
      },
      "how": "Targets stubborn melasma and post-inflammatory pigment — key for South-Asian skin."
    },
    "kojicAcid": {
      "name": "Kojic Acid",
      "evidence": "good",
      "treats": {
        "pigmentation": 0.6,
        "skinTone": 0.6
      },
      "how": "Tyrosinase inhibitor that fades dark spots and brightens."
    },
    "bakuchiol": {
      "name": "Bakuchiol",
      "evidence": "good",
      "treats": {
        "lines": 0.6,
        "uniformity": 0.4
      },
      "how": "Plant retinol alternative — smooths lines with less irritation; gentler for sensitive/deeper skin."
    },
    "ferulicAcid": {
      "name": "Ferulic Acid",
      "evidence": "good",
      "treats": {
        "skinTone": 0.4,
        "lines": 0.3
      },
      "how": "Antioxidant that boosts and stabilises Vitamin C."
    },
    "greenTea": {
      "name": "Green Tea (EGCG)",
      "evidence": "good",
      "treats": {
        "oiliness": 0.5,
        "redness": 0.5,
        "acne": 0.4
      },
      "how": "Antioxidant that calms inflammation and helps control oil."
    }
  },
  "skinAge": {
    "_note": "perceived skin age = profile age adjusted by weighted concern scores",
    "weights": {
      "lines": 0.34,
      "uniformity": 0.2,
      "darkCircles": 0.16,
      "pigmentation": 0.14,
      "hydration": 0.1,
      "skinTone": 0.06
    }
  },
  "archetype": {
    "_note": "3-axis skin type (barrier × reactivity × tone) -> a memorable archetype + blurb",
    "barrier": {
      "oily": "Oily",
      "dry": "Dry",
      "balanced": "Balanced"
    },
    "reactivity": {
      "reactive": "Sensitive",
      "resilient": "Resilient"
    },
    "tone": {
      "uneven": "Uneven-tone",
      "even": "Even-tone"
    },
    "blurbs": {
      "Oily": "Your skin runs oily and is breakout-prone — it loves lightweight, oil-balancing actives.",
      "Dry": "Your skin leans dry and needs humectants + barrier repair to stay plump.",
      "Balanced": "Your barrier is fairly balanced — keep it that way with gentle, consistent care.",
      "Sensitive": "Your skin reacts easily — fewer, gentler products and a strong barrier suit you best.",
      "Resilient": "Your skin tolerates actives well — you can build a fuller routine.",
      "Uneven-tone": "Tone and pigmentation are your edge to win — brightening + daily SPF is key.",
      "Even-tone": "Your tone is already even — protect it with antioxidants and SPF."
    }
  },
  "timelines": {
    "salicylicAcid": "2–4 weeks",
    "niacinamide": "4–6 weeks",
    "retinol": "8–12 weeks",
    "vitaminC": "4–8 weeks",
    "alphaArbutin": "6–10 weeks",
    "hyaluronicAcid": "1–7 days",
    "spf": "prevents daily",
    "zincPCA": "2–4 weeks",
    "riceFerment": "3–6 weeks",
    "teaTree": "2–4 weeks",
    "licorice": "6–8 weeks",
    "panthenol": "1–2 weeks",
    "charcoal": "immediate",
    "vitaminE": "4–6 weeks",
    "azelaicAcid": "8–12 weeks",
    "glycolicAcid": "2–4 weeks",
    "lacticAcid": "2–4 weeks",
    "ceramides": "1–2 weeks",
    "peptides": "8–12 weeks",
    "centella": "1–2 weeks",
    "tranexamicAcid": "8–12 weeks",
    "kojicAcid": "6–10 weeks",
    "bakuchiol": "8–12 weeks",
    "ferulicAcid": "4–8 weeks",
    "greenTea": "4–6 weeks"
  },
  "conflicts": [
    [
      "retinol",
      "salicylicAcid",
      "Alternate nights — both renew skin, together they can irritate."
    ],
    [
      "retinol",
      "vitaminC",
      "Use Vitamin C in the morning and Retinol at night."
    ]
  ],
  "clinicalScales": {
    "_note": "Maps our 0..100 (100=best) to recognised dermatology scales so grades are defensible, not arbitrary. These are interpretive labels, NOT a diagnosis.",
    "acne": {
      "ref": "IGA (Investigator's Global Assessment 0–4)",
      "bands": [
        [
          85,
          "IGA 0 · Clear"
        ],
        [
          70,
          "IGA 1 · Almost clear"
        ],
        [
          50,
          "IGA 2 · Mild"
        ],
        [
          30,
          "IGA 3 · Moderate"
        ],
        [
          0,
          "IGA 4 · Severe"
        ]
      ]
    },
    "lines": {
      "ref": "Glogau photoaging I–IV",
      "bands": [
        [
          85,
          "Glogau I · No wrinkles"
        ],
        [
          65,
          "Glogau II · Early lines"
        ],
        [
          40,
          "Glogau III · Visible lines"
        ],
        [
          0,
          "Glogau IV · Advanced"
        ]
      ]
    },
    "pigmentation": {
      "ref": "MASI-informed pigment load",
      "bands": [
        [
          85,
          "Minimal"
        ],
        [
          60,
          "Mild"
        ],
        [
          35,
          "Moderate"
        ],
        [
          0,
          "Marked"
        ]
      ]
    }
  },
  "safety": {
    "_note": "Responsible triage — this tool does NOT diagnose. If a localised lesion looks atypical we recommend a professional, per the ABCDE rule. Never give reassurance about cancer.",
    "abcde": "Asymmetry, irregular Border, uneven Colour, Diameter >6mm, Evolving/changing.",
    "flagMessage": "We noticed a distinct spot or mole. This tool can't assess lesions or moles — if it's new, changing, asymmetric, multi-coloured, or larger than a pencil eraser, please have a dermatologist check it (ABCDE rule).",
    "clearMessage": "We didn't flag anything unusual in this scan. This is a cosmetic screen, not a medical exam — see a doctor for any persistent or changing skin concern."
  },
  "regionalContext": {
    "_note": "Evidence-informed context for South-Asian / Pakistani skin (mostly Fitzpatrick III–V, Monk 4–8). Used to weight advice — not a diagnosis.",
    "pigmentation": "Melasma and post-inflammatory hyperpigmentation (PIH) are the #1 concern in melanin-rich skin — marks form easily and linger for months. Daily broad-spectrum SPF is non-negotiable and actives must be gentle to avoid triggering more PIH.",
    "acne": "Heat, humidity and pollution raise sebum and clogging; breakouts leave dark PIH marks rather than lasting redness. Avoid harsh scrubs — they deepen marks.",
    "oiliness": "A hot, humid climate keeps sebum high most of the year — lightweight, non-comedogenic textures perform best.",
    "sun": "High year-round UV makes daily SPF the single highest-impact step for tone, pigmentation and ageing — even indoors or on cloudy days.",
    "sensitivity": "Strong actives and over-exfoliation commonly trigger PIH in deeper tones — introduce one active at a time and patch-test.",
    "fitzpatrickAdvice": {
      "III": "Tans easily, burns moderately — SPF + antioxidants prevent tanning and uneven tone.",
      "IV": "Rarely burns, tans readily — pigment control (arbutin, niacinamide, tranexamic acid) plus SPF is key.",
      "V": "Very melanin-rich — prioritise gentle brightening and strict SPF; avoid aggressive actives that cause PIH."
    }
  }
};
